import { FC } from 'react'
import clsx from 'clsx'

import CustomLector from 'components/parts/custom-lector/custom-lector'
import AuthorLector from 'components/parts/author-lector/author-lector'

import { lectorOrigin } from 'utils/analytics/other/sub_lector/sub_lector'
import { ILectorsData } from 'constants/types/webinar.types'

import styles from './video-block.module.scss'

interface IVideoLectorsBlock {
  lectorsData: ILectorsData
  isEnded?: boolean
  lecturName?: string
  isTranslationPage?: boolean
  isHideRecommendations?: boolean
}

const VideoLectorsBlock: FC<IVideoLectorsBlock> = ({
  lectorsData,
  isEnded,
  lecturName,
  isTranslationPage,
  isHideRecommendations,
}) => {
  const { lectors, subscribeLector } = lectorsData

  const CustomAuthor = (props: any) => <AuthorLector {...props} modificator={styles.author} />

  return (
    <div className={styles.statsBordered}>
      <h2
        className={clsx(styles.title, styles.lectorTitle, {
          [styles.titleTranslation]: isTranslationPage,
          [styles.titleNoRecommend]: isHideRecommendations,
        })}
      >
        Лекторы
      </h2>
      <div
        className={clsx(styles.lectorsWrapper, {
          [styles.lectorsTranslation]: isTranslationPage,
          [styles.lectorsNorecommend]: isHideRecommendations,
        })}
      >
        {lectors.map((lectur) => (
          <AuthorLector
            key={lectur.id}
            lectorData={{ ...lectur, isTranslating: !isEnded, small: true }}
            subscribeLector={subscribeLector}
            modificator={styles.author}
            origin={isEnded ? lectorOrigin.WEBINAR_PAST : lectorOrigin.WEBINAR_LIVE}
            withLink
            withRegalia
            isVertical={isHideRecommendations}
            nameModificator={styles.lectorNameMod}
          />
        ))}
        <CustomLector lecturName={lecturName} LectorComponent={CustomAuthor} />
      </div>
    </div>
  )
}

export default VideoLectorsBlock
